module.exports = __webpack_public_path__ + "static/CookieRun-Bold-b01731e0798bd4242f0b2a058601b173.ttf";